import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlSerializer,
  UrlTree,
} from '@angular/router'

import { AuthenticationRepository } from '../../repositories/authentication-repository.service'
import { AuthenticationService } from '../../services/authentication.service'
import { OAuthService } from 'angular-oauth2-oidc'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private readonly router: Router,
    private readonly serializer: UrlSerializer,
    private readonly authService: AuthenticationService,
    private readonly authenticationRepository: AuthenticationRepository,
    private readonly oauthService: OAuthService
  ) {}

  async canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    await this.authService.waitUntilInitialized

    if (this.authenticationRepository.authenticated$.value) {
      return true
    } else {
      const rawUrl = window.location.pathname + window.location.search + window.location.hash
      const parsedUrl = this.serializer.parse(rawUrl)
      const targetUrl = this.router.serializeUrl(parsedUrl)
      this.oauthService.initLoginFlow(targetUrl)

      return false
    }
  }
}
